// import { Navigate } from 'react-router-dom';
// import useNavdata from '../layouts/useNavdata';

function ProtectedRoute({ component }) {
  // const menus = useNavdata();

  // const isDashboardOrPublic = () => ['/dashboard', '/profile']?.includes(path);

  // const isHRPath = path.includes('/hr');

  // // Check access based on menu config (role-based modules)
  // const isRouteAllowed = () =>
  //   menus.some(menu => {
  //     if (menu.link === path) return true;
  //     return menu.subItems?.some(subItem => subItem.link === path);
  //   });

  // // HR Access Control
  // if (isHRPath) {
  //   // f user can view HR routes
  //   if (isRouteAllowed()) {
  //     return component;
  //   }
  //   // Not authorized to view HR routes
  //   return <Navigate to="/hr/dashboard" />;
  // }

  // // Always allow public/dashboard/self-service routes
  // if (isDashboardOrPublic()) {
  //   return component;
  // }

  // return isRouteAllowed() ? component : <Navigate to="/dashboard" />;
  return component;
}

export default ProtectedRoute;
